<template>
    <div class="lang arabic">
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">
                        الخدمات المقدمة في وحدة العناية المركزة والاحتياطات التي يجب الانتباه لها
                    </a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">المستلزمات المطلوب إحضارها</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">جولات الأطباء</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">الوجبات</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">تعليمات الزيارة والاحتياطات التي يجب الانتباه لها</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">أخرى</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">قائمة المواد المطلوبة عند دخول وحدة العناية المركزة</a>
                </li>
            </ul>
        </div>

        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper :cssMode="true" :navigation="{
					nextEl: '.subSwiper-next',
					prevEl: '.subSwiper-prev'
				}" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/info-img02.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img03.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img04.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper :cssMode="true" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/intensive01-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">الخدمات المقدمة في وحدة العناية المركزة والاحتياطات التي يجب الانتباه لها</h3>
            <p class="bullet04 num1 depth">يتم توفير الرعاية التمريضية الأساسية مثل: سحب السوائل، وتغيير الوضعية، والاستحمام الجزئي، وإدارة التبول، والتبرز، والمساعدة في تناول الطعام.</p>
            <p class="bullet04 num2 depth">طريقة نداء الاستغاثة في حالات الطوارئ: في حالة الطوارئ أو عندما تحتاج إلى مساعدة من ممرضة، يمكنك الضغط على جرس الطوارئ الموجود بجانب السرير لاستدعاء الممرضة للحصول على المساعدة الفورية.</p>
            <p class="bullet04 num3 depth">قد تحدث تغييرات في الغرف داخل وحدة العناية المركزة لمكافحة العدوى والعلاج الخاص في وحدة العناية المركزة.</p>
            <p class="bullet04 num4 depth">
                <span>
                    <span class="font-main">يمكن تطبيق واقيات الجسم </span> 
                    للحفاظ على الأدوات أو المعدات الطبية التي تؤثر بشكل مباشر على الجهاز التنفسي والقلب والأوعية الدموية للمريض، مثل الأنابيب المختلفة (القسطرة، وأنابيب النزح، والقنوات، إلخ)، وأجهزة التنفس الصناعي، والدورات الدموية خارج الجسم، وغيرها، ولمنع إيذاء النفس وأذى الآخرين، وتكون الإجراءات كما يلي:  
                </span>
            </p>
            <p class="bullet05 depth">يتم تطبيقها بعد شرح الطبيب المسؤول للمريض أو المرافق ضرورة حماية الجسم، وملاحظة المنطقة المطبق عليها واقيات الجسم كل ساعتين على الأقل.</p>
            <p class="bullet05 depth">في حالات الطوارئ، قد يطبقها الطاقم الطبي أولًا ثم يشرحها للمرافق.</p>
            <p class="bullet04 num5 depth">يجب إبلاغ الطبيب والممرضة المسؤولة عن الأدوية التي يحضرها المريض قبل دخوله المستشفى. ولا يمكن للمريض التناول العشوائي لأي أدوية قام بإحضارها قبل دخوله المستشفى.</p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">المستلزمات المطلوب إحضارها</h3>
            <p class=" depth">يرجى تحضير المناديل المبللة، والحفاضات، ومفارش الأسرة الطبية، والكمامات التي سيستخدمها المريض.</p>
        </div>
        <div id="step3" class="step-item info">
            <h3 class="bullet01">جولات الأطباء</h3>
            <p class="bullet04 num1 depth">تكون جولات الأطباء من الساعة 8:00 إلى الساعة 10:00 صباحًا، وقد تختلف حسب ظروف القسم الطبي.</p>
            <p class="bullet04 num2 depth">إذا كان المريض يرغب في لقاء الطبيب خلال الجولة، عليه إخبار الممرضة المسؤولة بذلك.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">الوجبات</h3>
            <p class="bullet04 num1 depth">أوقات الوجبات للمرضى الذين يمكنهم تناول الطعام هي: الإفطار: 7:00 إلى 8:00 صباحًا، الغداء: 12:00 إلى 1:00 ظهرًا، والعشاء: 6:00 إلى 7:00 مساءً.</p>
            <p class="bullet04 num2 depth">إذا رغب المريض، يمكنه اختيار "وجبة خاصة" غير مشمولة بالتأمين، وفي هذه الحالة سيتحمل المريض تكلفة الوجبة بالكامل.</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">تعليمات الزيارة والاحتياطات التي يجب الانتباه لها</h3>
            <p class="bullet04 num1 depth">أوقات الزيارة الرسمية</p>
            <div class="table mt20 ">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2">الفئة</th>
                                <th>اليوم</th>
                                <th>الوقت</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2">وحدة العناية المركزة الشاملة</td>
                                <td>وحدة العناية المركزة العصبية</td>
                                <td>يوميًا</td>
                                <td rowspan="4">13:00 ~ 13:20</td>
                            </tr>
                            <tr>
                                <td>وحدة العناية المركزة للطب الباطني</td>
                                <td>يوميًا</td>
                            </tr>
                            <tr>
                                <td rowspan="2">وحدة العناية المركزة الجراحية</td>
                                <td>وحدة العناية المركزة الجراحية</td>
                                <td>يوميًا</td>
                            </tr>
                            <tr>
                                <td>وحدة العناية المركزة للقلب والأوعية الدموية</td>
                                <td>يوميًا</td>
                            </tr>
                            <tr>
                                <td>وحدة العناية المركزة للأوعية الدموية الأبهري</td>
                                <td>وحدة العناية المركزة للأوعية الدموية الأبهري</td>
                                <td>يوميًا</td>
                                <td>12:30 ~ 12:50</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p class="bullet04 num2 depth mt20">قد يتم فرض قيود على الزيارة أو تأخيرها حسب الحالة في وحدة العناية المركزة.</p>
            <p class="bullet04 num3 depth">لأغراض مكافحة العدوى، يقتصر عدد الزوار على شخص واحد فقط ولا يُسمح بالمناوبات.</p>
            <p class="bullet04 num4 depth">لضمان استقرار المريض والوقاية من العدوى، يُمنع دخول الأطفال دون سن 12 سنة ذوي المناعة الضعيفة أو أفراد الأسرة المصابين بنزلات البرد أو الأمراض المعدية ويجب الالتزام بمواعيد الزيارة.</p>
            <p class="bullet04 num5 depth">قبل وبعد الزيارة، يرجى التأكد من استخدام معقم اليدين أو غسل يديك في المغسلة عند مدخل وحدة العناية المركزة.</p>
            <p class="bullet04 num6 depth">عند الزيارة، يرجى ارتداء الرداء البلاستيكي المتوفر عند مدخل وحدة العناية المركزة. وقبل مغادرة وحدة العناية المركزة، يرجى خلع الرداء البلاستيكي، وغسل يديك قبل الخروج.</p>
            <p class="bullet04 num7 depth">عند الزيارة يرجى مراعاة ما يلي لمنع السقوط:</p>
            <p class="bullet05 depth">قم دائمًا برفع حواجز السرير على كلا الجانبين.</p>
            <p class="bullet05 depth">إذا كنت بحاجة إلى مساعدة، يرجى نداء الممرضة أو استدعاؤها.</p>
            <p class="bullet04 num8 depth">يجب إيقاف تشغيل الهواتف المحمولة داخل وحدة العناية المركزة نظرًا لأنها قد تسبب خللًا في الأجهزة الطبية بسبب التداخل اللاسلكي.</p>
            <p class="bullet04 num9 depth">أثناء الزيارة، يرجى إبلاغ الطاقم الطبي فورًا إذا لاحظت أي علامات غير طبيعية على المريض (تغير في الوعي، ألم في الصدر، نزيف، تشنجات، ألم، إلخ).</p>
            <p class="bullet04 num10 depth">بالنسبة للأطفال المرضى، قد يتم تنفيذ إجراءات التحقق من الهوية عند الزيارة لمنع الاختطاف وضمان السلامة.</p>
            <p class="bullet04 num11 depth">يرجى التعاون والتسجيل في قائمة الزوار حتى يتسنى لنا تنظيم الزيارات بشكل مناسب. </p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">أخرى</h3>
            <h4 class="bullet02 type2 num1 depth">مرافق الراحة</h4>
            <p class="depth">تتوفر ماكينات دفع الرسوم الطبية آليًا، وماكينات تسجيل أقراص الفيديو المدمجة، ومتاجر، وبنوك، مقاهي، وقاعة الطعام، ومخابز، وأجهزة طبية، وصناديق الطرود الآلية.</p>

            <h4 class="bullet02 type2 num2 depth">طرق الوقاية من الحرائق والتعامل معها</h4>
            <p class="depth">
                يرجى الامتناع عن استخدام مواقد الغاز المحمولة، والمراوح، والسخانات الكهربائية، أو إدخال المواد القابلة للاشتعال إلى غرف انتظار عائلات المرضى. في حالة حدوث حريق، يرجى إبلاغ طاقم المستشفى فورًا واتباع تعليمات الطاقم للإخلاء عبر غرفة الإخلاء وسلالم الطوارئ.
            </p>

            <h4 class="bullet02 type2 num3 depth">الامتناع عن التدخين</h4>
            <p class="depth">من أجل صحة المرضى والوقاية من الحرائق، يُحظر التدخين في جميع مرافق المستشفى، لذا يرجى منكم التعاون والامتناع عن التدخين.</p>

            <h4 class="bullet02 type2 num4 depth">التعامل مع الشكاوى والتظلمات</h4>
            <p class="depth">
                إذا كانت لديك أية استفسارات أو شعرت بالانزعاج أثناء استخدام مرافق المستشفى، أو لديك أي شيء ترغب في الإشادة به، يمكنك ذلك من خلال زيارة غرفة استشارات العملاء في الطابق الأول، أو الاتصال عبر الهاتف، أو زيارة الموقع الإلكتروني للمستشفى.
            </p>

            <h4 class="bullet02 type2 num5 depth">رسوم مواقف السيارات</h4>
            <p class="depth">
                يرجى الرجوع إلى تعليمات رسوم مواقف السيارات المنشورة على لوحة الإعلانات عند مدخل وحدة العناية المركزة.
            </p>

            <h4 class="bullet02 type2 num6 depth">تنبيه بشأن فقدان أو سرقة المتعلقات الشخصية</h4>
            <p class="depth">
                لا يمكنك الاحتفاظ بالأشياء الثمينة والنقود في وحدة العناية المركزة. يرجى الاحتفاظ بها بشكل شخصي أو الاتصال بقسم الشؤون الإدارية بالمستشفى. كما أنه يجب إزالة الأدوات المساعدة مثل أطقم الأسنان، والمعينات السمعية، والنظارات الطبية، والعدسات، وغيرها أثناء الفحوصات والإجراءات الطبية والعمليات الجراحية وحالات الطوارئ، لذا يرجى الاحتفاظ بها بشكل آمن.
                <br>
                يُرجى العلم بأن المستشفى غير مسؤول عن أي حادث فقدان ناتج عن الإهمال الشخصي.
            </p>

            <h4 class="bullet02 type2 num7 depth">الاحتفاظ بالمتعلقات الشخصية</h4>
            <ul class="bullet-list type2 depth">
                <li class="bullet-item">نظارات </li>
                <li class="bullet-item">طقم أسنان </li>
                <li class="bullet-item">معينات سمعية </li>
                <li class="bullet-item">محفظة </li>
                <li class="bullet-item">هاتف محمول </li>
                <li class="bullet-item">ملابس </li>
                <li class="bullet-item">أحذية </li>
                <li class="bullet-item">مفاتيح </li>
                <li class="bullet-item">ساعة يد </li>
                <li class="bullet-item">أقراط </li>
                <li class="bullet-item">قلادة </li>
                <li class="bullet-item">خاتم </li>
                <li class="bullet-item">سوار </li>
                <li class="bullet-item">خلخال  </li>
                <li class="bullet-item">أخرى ( <span class="gap50"></span> )</li>
            </ul>


            <h4 class="bullet02 type2 num8 depth">دليل المرافق الدينية</h4>
            <p class="depth">
                يعد هذا المستشفى مستشفى مسيحيًا، ويُقام قداس يوم الأحد في الساعة 10 صباحًا، وقداس الأربعاء في الساعة 5 مساءً، وخدمة الأطفال والشباب يوم الخميس في الساعة 10 صباحًا، وذلك في كنيسة "بانغجو" بالطابق الثالث من المبنى C. للاستفسارات حول الزيارات الرعوية، والاستشارات الدينية، أو المشورة الروحية، يمكن الاتصال بغرفة الاستشارات الرعوية على الرقم (02-6986-5724). توجد غرفة الاستشارات الرعوية والقاعة المخصصة للصلاة أيضًا في الطابق الثالث من المبنى C.
            </p>

            <h4 class="bullet02 type2 num9 depth">تعليمات إجراءات الخروج</h4>
            <p class="depth">بعد مراجعة التأمين الطبي، سيتم إرسال رسالة نصية إلى المريض أو المرافق. يمكن دفع رسوم الخروج عبر شباك الدخول والخروج في قسم الشؤون الإدارية أو باستخدام ماكينة الدفع الآلي. وبعد السداد، يمكن استلام أدوية الخروج من المستشفى من مكتب التمريض.</p>

            <h4 class="bullet02 type2 num10 depth">إصدار الوثائق والشهادات: </h4>
            <p class="depth">يرجى إبلاغ الطبيب المسؤول أو الممرضة مسبقًا بالوثائق المطلوبة، مثل التقارير الطبية، نسخ السجلات الطبية أو الأشعة.</p>

            <h4 class="bullet02 type2 num11 depth">نحن نحترم ونحمي حقوق وواجبات المرضى في جميع مراحل العلاج.</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>حقوق المرضى</th>
                                <th>واجبات المرضى</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">الحق في تلقي الرعاية الطبية</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">الالتزام بالثقة واحترام العاملين في المجال الطبي</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">الحق في المعرفة وحق اتخاذ القرارات الشخصية </p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">الحق في حماية السرية</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">الالتزام بعدم تلقي العلاج الطبي بوسائل غير قانونية</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">الحق في طلب الاستشارة والتسوية</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">الحق في الحصول على الخدمات الطبية في بيئة طبية آمنة</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h4 class="bullet02 type2 num12 depth mt20">
                إذا تعرض أي موظف للاعتداء من المريض أو المرافق له (الزائر) (مثل العنف اللفظي، التهديدات، الشغب، الاعتداء الجنسي، التحرش الجنسي، أو تخريب الممتلكات)، فقد تتم معاقبته وفقًا للقوانين ذات الصلة المعمول بها.
            </h4>

            <h4 class="bullet02 type2 num13 depth mt20">
                إذا قام المريض أو المرافق أو أي شخص بارتكاب أعمال قد تشكل إهانة أو تشهيرًا أو اعتداء أو عرقلة سير العمل ضد أفراد الطاقم الطبي، وبالتالي منعهم من تقديم الخدمات الطبية بشكل طبيعي، يجوز لأفراد الطاقم الطبي رفض تقديم الخدمات الطبية (الحق في رفض تقديم الخدمات الطبية) في النطاق الذي لا يُنتهك فيه قانون الخدمات الطبية وقانون خدمات الطوارئ الطبية.
            </h4>

            <h4 class="bullet02 type2 num14 depth mt20">
                أثناء الإقامة في المستشفى، يتم ملاحظة حالة المريض من خلال كاميرات المراقبة، ولكن لا يتم تسجيل الفيديوهات.
            </h4>

        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">قائمة المواد المطلوبة عند دخول وحدة العناية المركزة</h3>

            <h4 class="bullet02 depth">تعليمات الزيارة في وحدة العناية المركزة</h4>
            <p class="depth">ساعات الزيارة الرسمية في وحدة العناية المركزة: (12:30 ~ 12:50) يوميًا</p>

            <h4 class="bullet02 depth">دليل الانتقال من وحدة العناية المركزة إلى الأجنحة العادية</h4>
            <p class="depth">
                عند الانتقال من وحدة العناية المركزة إلى الأجنحة العادية، يتطلب الأمر وجود مقدم رعاية أو مرافق قادر على رعاية المريض على مدار الساعة. كما يُنصح بتحضير نعال مريحة للمرضى القادرين على الحركة.
            </p>

            <h4 class="bullet02 depth">أخرى</h4>
            <p class="depth">يرجى تفهم أنه في حالة وجود مريض في حالة طارئة للغاية، يجوز نقله إلى غرفة أخرى بشكل طارئ بغض النظر عن الوقت، اعتمادًا على تقدير القسم الطبي.</p>

            <h4 class="bullet02 depth">قائمة المواد المطلوبة في غرفة العناية المركزة</h4>
            <div class="need-item">
                <div class="need-item__text">
                    <p class="bullet04 num1 depth">الأدوية التي يتناولها المريض قبل الإقامة في المستشفى (باستثناء أدوية المستشفى)</p>
                    <p class="bullet04 num2 depth">حفاضات (حفاضات بالأجنحة O، حفاضات سراويل X)</p>
                    <p class="bullet04 num3 depth">مفارش الأسرة الطبية، مناديل مبللة (حجم كبير)</p>
                    <p class="bullet04 num4 depth">فازلين للشفاه</p>
                    <p class="bullet04 num5 depth">أكواب ورقية، مياه معبأة 500 مل * 2 (إذا لزم الأمر)</p>
                    <p class="bullet04 num6 depth">في حالة الوعي: فرشاة أسنان، معجون أسنان، كوب ماء على شكل ماصة، علبة مناديل ورقية</p>


                    <!-- <p class="bullet04 num7 depth"><span><span class="font-main">수술 후 환자의 경우</span>(필요시):트리플로우(호흡기치료기)*1</span></p>
                    <p class="bullet05 depth">지하1층 의료기상사에서 구입가능</p> -->
                </div>
                <div class="need-item__img">
                    <img src="@/assets/resource/img/needitem.png" alt="">
                </div>
            </div>

            <h4 class="bullet02 depth">تعليمات حول حظر الاحتفاظ بالممتلكات الثمينة في غرفة العناية المركزة</h4>
            <p class="depth">لا يُسمح باستخدام الهواتف المحمولة الشخصية في غرفة العناية المركزة. لا يتحمل المستشفى المسؤولية في حالة فقدان أي ممتلكات ثمينة، لذا يُنصح بأن تأخذوا جميع ممتلكاتكم الثمينة معكم. يرجى إعلام الطاقم الطبي في حال ارتداء أطقم أسنان / المعينات السمعية.</p>

            <h4 class="bullet02 depth">أماكن شراء المستلزمات</h4>
            <p class="bullet03 depth">24 ساعة : <span class="font-main">متجر CU في الطابق B1</span></p>
            <p class="bullet03 depth">من الإثنين إلى الجمعة من 9 صباحًا حتى 6 مساءً: <span class="font-main">متجر الأجهزة الطبية في الطابق B1</span></p>
        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>